// same RegEx that's used in the api
export const EmailValidator = {
    // typescript complains because RegExp.test doesn't take undefined
    test: (email: string | undefined) => {
        const regEx = new RegExp(/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/);
        return email ? regEx.test(email) : false;
    }
};
